module.exports = __webpack_public_path__ + "img/HC1038-74.c9e5f534.jpg";